import { useTranslation } from 'utils/i18n';
import { SearchOptions } from '.';

interface Props {
  onClick: (options: SearchOptions) => void;
  options: SearchOptions;
}

const searchToText = (options: SearchOptions) => {
  const { t } = useTranslation('common');

  const query: string[] = [];
  const { location, property = [], distance, capacity, facets = [] } = options;

  if (location) {
    query.push(location);
  }

  if (property.length > 0) {
    query.push(property.join(', '));
  }

  if (distance) {
    query.push(t('previous_searches.within_x_miles', { miles: distance }));
  }

  if (capacity) {
    query.push(t('previous_searches.capacity_x', { capacity }));
  }

  if (facets.length > 0) {
    query.push(facets.join(', '));
  }

  return query.join(', ');
};

const SearchQuery = ({ options, onClick }: Props) => {
  return (
    <li>
      <button className="button button--text" onClick={() => onClick(options)}>
        {searchToText(options)}
      </button>
    </li>
  );
};

export default SearchQuery;
